import { Capacitor } from '@capacitor/core';

// Läuft die App in der nativen Capacitor-Hülle (iOS/Android)?
export function isNativeApp() {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

// Läuft die Web-App als installierte PWA (zum Homescreen hinzugefügt / standalone)?
export function isStandalonePWA() {
  if (typeof window === 'undefined') return false;
  const standaloneMatch =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(display-mode: standalone)').matches;
  // iOS Safari nutzt navigator.standalone statt display-mode
  return Boolean(standaloneMatch || window.navigator.standalone === true);
}

// "Installierte App" = native App ODER installierte PWA.
// Offline-Funktionen ergeben nur hier Sinn – im normalen Browser-Tab nicht.
export function isInstalledApp() {
  return isNativeApp() || isStandalonePWA();
}

// URL für einen Decode-Pfad-Sound (wird per fetch+decodeAudioData geladen).
// WKWebView in der nativen Capacitor-Hülle (capacitor://) kann mp3 via
// decodeAudioData NICHT zuverlässig dekodieren (decodeAudioData → null) – obwohl
// Desktop-Browser UND iOS-Safari/PWA es problemlos können. Lösung: in der nativen
// App WAV laden (dekodiert zuverlässig), im Browser/PWA weiterhin das kleinere mp3.
// `base` ohne Endung, z.B. soundUrl('boxcounter') → '/sounds/boxcounter.wav'|'.mp3'.
export function soundUrl(base) {
  return `/sounds/${base}.${isNativeApp() ? 'wav' : 'mp3'}`;
}

// Lädt eine lokale Datei als ArrayBuffer via XMLHttpRequest.
// Hintergrund: In der nativen Capacitor-Hülle (capacitor://localhost) schlägt
// `fetch()` für Bundle-Dateien fehl (Response status 0, leerer Body) – belegt per
// Geräte-Log. `XMLHttpRequest` liefert die Bytes dagegen vollständig; das
// Custom-Scheme meldet zwar `status 0`, übergibt aber den kompletten Body. Im
// Browser/PWA ist es ein normaler 200er. Daher NICHT auf status===200 prüfen,
// sondern darauf, dass tatsächlich Bytes ankamen.
export function loadArrayBuffer(url) {
  return new Promise((resolve, reject) => {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = () => {
        if (xhr.response && xhr.response.byteLength > 0) resolve(xhr.response);
        else reject(new Error(`empty audio response (status ${xhr.status})`));
      };
      xhr.onerror = () => reject(new Error(`audio xhr error (status ${xhr.status})`));
      xhr.send();
    } catch (e) {
      reject(e);
    }
  });
}
